import React from 'react'
import { useParams } from 'react-router'
import styled from 'styled-components'
import theme from './theme'
import Actions from './Actions';

const msg = {
  403: "Vous n'avez pas accès a cet espace",
  404: 'Oups, on n\'a rien trouvé à cette adresse..',
  500: 'Une erreur est survenue !'
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  & > .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: url("/images/RATP.svg");
    background-position: center;
    background-repeat: no-repeat;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;  
  }
  & > .content > .title {
    color: ${ theme.palette.blue };
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  & > .content > .btn {
    margin-top: 40px;
  }
`


function ErrorPage({ ...props }) {

  const { status } = useParams()

  return <Container>
    <div className="content">
      <div className='title'>ERREUR { status }</div>
      <div> { msg[status] }</div>
      <Actions className={ 'btn' }
               submitTxt="Page d'accueil" submitHref='/'
               cancelTxt='Se déconnecter' cancelLink='/logout'
      />
    </div>
  </Container>
}

export default ErrorPage
